import { RawHtml } from '../../adminv3/types/block';

export type WritingQuestionId = number;
export enum WritingQuestionType {
  SINGLE_SELECT = 'single_select',
  MULTI_SELECT = 'multi_select',
}

export enum WritingQuestionStatus {
  PUBLIC = 'public',
  HIDDEN = 'hidden',
}

export type BaseWritingQuestion<C> = {
  id: WritingQuestionId;
  sentence: string;
  description: RawHtml;
  answer_description: RawHtml;
  content: C;
  status: WritingQuestionStatus;
  position: number;
};

export type ChoiceId = string;

export type ChoiceSpec = {
  id: ChoiceId;
  label: string;
  answer: boolean;
};

export type SelectQuestionContent = {
  choices: ChoiceSpec[];
};

export type SingleSelectQuestion = {
  question_type: WritingQuestionType.SINGLE_SELECT;
} & BaseWritingQuestion<SelectQuestionContent>;

export type MultiSelectQuestion = {
  question_type: WritingQuestionType.MULTI_SELECT;
} & BaseWritingQuestion<SelectQuestionContent>;

export type WritingQuestion = SingleSelectQuestion | MultiSelectQuestion;
